import axios from 'axios';

export default {
    state: {
        terminals: null,
    },
    getters: {
        getTerminals(state) {
            return state.terminals
        },
    },
    mutations: {
        setTerminals(state, data) {
            return state.terminals = data
        },
    },
    actions: {
        terminalsRequest(context) {
            return axios.get('/api/branches/list/terminals')
                .then(res => {
                    context.commit('setTerminals', res.data)
                })
        },
    }
}